import { useEffect } from 'react';
import { GtmService } from 'tradera/services/google-tagmanager-service';
import { useAppSelector } from 'tradera/state/hooks';
import {
    selectAutomaticTranslationPreferred,
    selectPreferredLanguageCode
} from 'tradera/state/language/selectors';
import { useGetItemsByIdsQuery } from 'tradera/state/services/discover-api';
import type { ItemsItemsByIdsRequest } from 'tradera/state/services/types/webapi-discover-generated';
import type { PossibleItemTypes } from 'tradera/components/item-card/item-card';

export const useGetRecentlyViewed = (loadingTriggerInView: boolean) => {
    const recentlyViewedItemIds: number[] =
        useAppSelector((state) => state.items.recentItemIds) ?? [];

    const hasAnyRecentItems = recentlyViewedItemIds.length > 0;
    const queryParams: ItemsItemsByIdsRequest = {
        searchLanguageCodeIso2: useAppSelector(selectPreferredLanguageCode),
        automaticTranslationPreferred: useAppSelector(
            selectAutomaticTranslationPreferred
        ),
        itemIds: recentlyViewedItemIds
    };

    const { data, isSuccess, isLoading } = useGetItemsByIdsQuery(queryParams, {
        skip: !loadingTriggerInView || !hasAnyRecentItems
    });

    useEffect(() => {
        if (isSuccess) {
            GtmService.trackAction(
                'StartPage',
                'recentlyViewed',
                'number of search results on load',
                data?.items?.length
            );
        }
    }, [data?.items, isSuccess]);

    return !loadingTriggerInView || isLoading
        ? recentlyViewedItemIds.map((itemId): PossibleItemTypes => ({ itemId }))
        : data?.items ?? [];
};
